export default __webpack_public_path__ + "static/media/nfc.fd1089b6.png";